import React, { useState } from 'react';
export function ContactSection() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Visual only for this implementation
    alert('Thanks for your interest! This is a visual demo, so no data was sent.');
    setFormData({
      name: '',
      email: '',
      phone: '',
      message: ''
    });
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };
  return <section id="contact" className="bg-charcoal py-16 md:py-28" data-id="element-30">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-31">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16" data-id="element-32">
          {/* Contact Info */}
          <div className="text-white" data-id="element-33">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-5 sm:mb-6" data-id="element-34">
              Ready to Transform Your Space?
            </h2>
            <p className="text-gray-300 text-base sm:text-lg mb-8 sm:mb-10 leading-relaxed max-w-md" data-id="element-35">
              Book a free consultation with our experienced designer/installer.
              We'll measure, recommend the perfect solution, and handle
              everything.
            </p>

            <div className="space-y-6 sm:space-y-8" data-id="element-36">
              <div data-id="element-37">
                <a href="tel:602-551-1539" className="text-2xl sm:text-4xl font-bold text-gold hover:text-gold-hover transition-colors" data-id="element-38">
                  602-551-1539
                </a>
              </div>

              <div className="space-y-2 text-gray-300 text-sm sm:text-base" data-id="element-39">
                <p data-id="element-40">
                  <a href="mailto:scottsdalepatioshade@gmail.com" className="hover:text-white transition-colors break-all sm:break-normal" data-id="element-41">
                    scottsdalepatioshade@gmail.com
                  </a>
                </p>
                <p data-id="element-42">1217 W Dunbar Dr, Phoenix, AZ 85041</p>
              </div>

              <div className="pt-5 sm:pt-6 border-t border-white/10" data-id="element-43">
                <h3 className="text-lg font-semibold text-white mb-4" data-id="element-44">
                  Business Hours
                </h3>
                <ul className="space-y-2 text-gray-300" data-id="element-45">
                  <li className="flex justify-between max-w-xs" data-id="element-46">
                    <span data-id="element-47">Mon–Fri:</span> <span data-id="element-48">9:00 AM – 5:00 PM</span>
                  </li>
                  <li className="flex justify-between max-w-xs" data-id="element-49">
                    <span data-id="element-50">Saturday:</span> <span data-id="element-51">10:00 AM – 3:00 PM</span>
                  </li>
                  <li className="flex justify-between max-w-xs" data-id="element-52">
                    <span data-id="element-53">Sunday:</span> <span data-id="element-54">Closed</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="bg-white/5 p-8 md:p-10 rounded-2xl border border-white/10 backdrop-blur-sm" data-id="element-55">
            <form onSubmit={handleSubmit} className="space-y-6" data-id="element-56">
              <div data-id="element-57">
                <label htmlFor="name" className="sr-only" data-id="element-58">
                  Name
                </label>
                <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} placeholder="Your Name" required className="w-full bg-white/10 border border-white/20 text-white placeholder-white/50 rounded-lg h-14 px-4 focus:outline-none focus:ring-2 focus:ring-gold focus:border-transparent transition-all" data-id="element-59" />
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-60">
                <div data-id="element-61">
                  <label htmlFor="email" className="sr-only" data-id="element-62">
                    Email
                  </label>
                  <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} placeholder="Email Address" required className="w-full bg-white/10 border border-white/20 text-white placeholder-white/50 rounded-lg h-14 px-4 focus:outline-none focus:ring-2 focus:ring-gold focus:border-transparent transition-all" data-id="element-63" />
                </div>
                <div data-id="element-64">
                  <label htmlFor="phone" className="sr-only" data-id="element-65">
                    Phone
                  </label>
                  <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} placeholder="Phone Number" required className="w-full bg-white/10 border border-white/20 text-white placeholder-white/50 rounded-lg h-14 px-4 focus:outline-none focus:ring-2 focus:ring-gold focus:border-transparent transition-all" data-id="element-66" />
                </div>
              </div>

              <div data-id="element-67">
                <label htmlFor="message" className="sr-only" data-id="element-68">
                  Message
                </label>
                <textarea id="message" name="message" value={formData.message} onChange={handleChange} placeholder="How can we help you?" required className="w-full bg-white/10 border border-white/20 text-white placeholder-white/50 rounded-lg h-32 p-4 focus:outline-none focus:ring-2 focus:ring-gold focus:border-transparent transition-all resize-none" data-id="element-69" />
              </div>

              <button type="submit" className="w-full bg-gold hover:bg-gold-hover text-charcoal font-bold rounded-full h-14 px-8 transition-all text-lg" data-id="element-70">
                Get My Free Quote
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>;
}